import { render, staticRenderFns } from "./ReportCatalogManage.vue?vue&type=template&id=37bbaf2c&scoped=true&"
import script from "./ReportCatalogManage.vue?vue&type=script&lang=js&"
export * from "./ReportCatalogManage.vue?vue&type=script&lang=js&"
import style0 from "./ReportCatalogManage.vue?vue&type=style&index=0&id=37bbaf2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bbaf2c",
  null
  
)

export default component.exports